export enum Mask {
  PhoneNumber = '999 999-9999',
  ExtendedPhoneNumber = '9 999 999-9999',
  PostalCode = 'a9a 9a9',
}
